import React from "react";

const IArrowBack = ({
  width = 18,
  height = 18,
  color = "#252526",
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      {...props}
    >
      <path
        d="M15.75 10.125V14.625C15.75 14.7742 15.6907 14.9173 15.5852 15.0227C15.4798 15.1282 15.3367 15.1875 15.1875 15.1875H2.8125C2.66332 15.1875 2.52024 15.1282 2.41475 15.0227C2.30926 14.9173 2.25 14.7742 2.25 14.625V10.125C2.25 9.97582 2.30926 9.83274 2.41475 9.72725C2.52024 9.62176 2.66332 9.5625 2.8125 9.5625C2.96168 9.5625 3.10476 9.62176 3.21025 9.72725C3.31574 9.83274 3.375 9.97582 3.375 10.125V14.0625H14.625V10.125C14.625 9.97582 14.6843 9.83274 14.7898 9.72725C14.8952 9.62176 15.0383 9.5625 15.1875 9.5625C15.3367 9.5625 15.4798 9.62176 15.5852 9.72725C15.6907 9.83274 15.75 9.97582 15.75 10.125ZM8.60203 10.523C8.65427 10.5753 8.71631 10.6168 8.7846 10.6451C8.85288 10.6734 8.92608 10.6879 9 10.6879C9.07392 10.6879 9.14712 10.6734 9.2154 10.6451C9.28369 10.6168 9.34573 10.5753 9.39797 10.523L12.2105 7.71047C12.2627 7.65821 12.3042 7.59616 12.3325 7.52788C12.3608 7.4596 12.3753 7.38641 12.3753 7.3125C12.3753 7.23859 12.3608 7.1654 12.3325 7.09712C12.3042 7.02884 12.2627 6.96679 12.2105 6.91453C12.1582 6.86227 12.0962 6.82081 12.0279 6.79253C11.9596 6.76424 11.8864 6.74969 11.8125 6.74969C11.7386 6.74969 11.6654 6.76424 11.5971 6.79253C11.5288 6.82081 11.4668 6.86227 11.4145 6.91453L9.5625 8.76727V2.25C9.5625 2.10082 9.50324 1.95774 9.39775 1.85225C9.29226 1.74676 9.14918 1.6875 9 1.6875C8.85082 1.6875 8.70774 1.74676 8.60225 1.85225C8.49676 1.95774 8.4375 2.10082 8.4375 2.25V8.76727L6.58547 6.91453C6.47992 6.80898 6.33677 6.74969 6.1875 6.74969C6.03823 6.74969 5.89508 6.80898 5.78953 6.91453C5.68398 7.02008 5.62469 7.16323 5.62469 7.3125C5.62469 7.46177 5.68398 7.60492 5.78953 7.71047L8.60203 10.523Z"
        fill={color}
      />
    </svg>
  );
};

export default IArrowBack;
